import React from 'react';
import Hero from '../components/Hero';
import { StatsBar, BonusBanner, Features, PlatformsSection, Difference, LearnSection, CTA } from '../components/Sections';
import { AccountTypes, Testimonials } from '../components/AccountsAndTestimonials';
import Footer from '../components/Footer';

const HomePage = () => (
  <div>
    <Hero/>
    <StatsBar/>
    <BonusBanner/>
    <Features/>
    <PlatformsSection/>
    <AccountTypes/>
    <Difference/>
    <Testimonials/>
    <LearnSection/>
    <CTA/>
    <Footer/>
  </div>
);

export default HomePage;
